import { TenantEntity } from '../TenantEntity'
import { getMAWBInfo } from '@/api/partner/airline'
export class AirLine extends TenantEntity {
  /**
   * @param {Object} data
   */
  constructor(data) {
    super(data)
  }

  get airlineCode() {
    return this._data.airlineCode
  }
  set airlineCode(airlineCode) {
    this._data.airlineCode = airlineCode
  }
  get mawbprefix() {
    return this._data.mawbprefix
  }
  set mawbprefix(mawbprefix) {
    this._data.mawbprefix = mawbprefix
  }
  get companyUuid() {
    return this._data.companyUuid
  }
  set companyUuid(companyUuid) {
    this._data.companyUuid = companyUuid
  }
  async getMAWBInfo() {
    const data = this._data
    if (typeof data.mAWBInfo !== 'object') {
      const result = await getMAWBInfo(data.uuid).then(res => res.data)
      if (result && result.length > 0) {
        data.mAWBInfo = result
      } else {
        data.mAWBInfo = []
      }
    }
    return data.mAWBInfo
  }
}
